export enum VenueTrustSignalDomain {
  Eater = 'eater.com',
  Infatuation = 'theinfatuation.com',
}

export const VENUE_TRUST_SIGNAL_LABELS: Record<VenueTrustSignalDomain, string> = {
  [VenueTrustSignalDomain.Eater]: 'Eater',
  [VenueTrustSignalDomain.Infatuation]: 'Infatuation',
}

export const EDITORIAL_RECOGNITION_TRUST_SIGNALS = [
  VenueTrustSignalDomain.Eater,
  VenueTrustSignalDomain.Infatuation,
] as const satisfies readonly VenueTrustSignalDomain[]

export const isVenueTrustSignalDomain = (value: string): value is VenueTrustSignalDomain =>
  Object.values(VenueTrustSignalDomain).includes(value as VenueTrustSignalDomain)
